module.exports = __webpack_public_path__ + "static/media/manager-b-1.790aee8a.png";